module.exports = __webpack_public_path__ + "img/10.731316c5.png";